/* Southwestern Equine: bell button on sold-out variant swatches.
   The bell opens the Restock Rocket (STOQ) back-in-stock modal for that swatch's variant,
   the same modal as the app's "Notify me when available" button, without changing the
   selected variant. Loaded from snippets/swe-product-purchase-quantity.liquid. */
(() => {
  if (window.sweNotifyBell) return;
  window.sweNotifyBell = true;

  const SOLD_OUT_SWATCH = '.swatch-element.variant-swatch.soldout[data-swatch-variant-id]';
  const TOOLTIP = "Email me when it's back";
  const ICON = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>';
  const products = new Map();

  function productJson(url) {
    // Restock Rocket's openModal takes the /products/<handle>.js shape
    if (!products.has(url)) {
      const request = fetch(`${url}.js`, { credentials: 'same-origin' })
        .then(response => {
          if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
          return response.json();
        })
        .catch(error => {
          products.delete(url);
          throw error;
        });
      products.set(url, request);
    }
    return products.get(url);
  }

  function addBell(swatch) {
    const input = swatch.querySelector('input[data-product-url]');
    if (!input || !swatch.dataset.swatchVariantId || swatch.querySelector(':scope > .swe-notify-bell')) return;

    // Keep the bell outside the <label> so pressing it never selects the swatch
    const bell = document.createElement('button');
    bell.type = 'button';
    bell.className = 'swe-notify-bell';
    bell.dataset.tip = TOOLTIP;
    bell.setAttribute('aria-label', `Email me when ${input.value} is back in stock`);
    bell.innerHTML = ICON;
    swatch.appendChild(bell);
  }

  function addBells() {
    document.querySelectorAll(SOLD_OUT_SWATCH).forEach(addBell);
  }

  async function openModal(bell) {
    const swatch = bell.closest('.swatch-element');
    const input = swatch && swatch.querySelector('input[data-product-url]');
    const restockRocket = window._RestockRocket;

    if (!input) return;
    if (!restockRocket || typeof restockRocket.openModal !== 'function') {
      // App not loaded: select the swatch so the normal notify button appears
      swatch.querySelector('label')?.click();
      return;
    }

    bell.setAttribute('aria-busy', 'true');
    try {
      const product = await productJson(input.dataset.productUrl);
      // The variant ID must be a number; the modal ignores a string ID
      restockRocket.openModal(product, Number(swatch.dataset.swatchVariantId));
    } catch (error) {
      // Opens for the current product with the app's own variant dropdown
      restockRocket.openModal();
    } finally {
      bell.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', event => {
    const bell = event.target instanceof Element && event.target.closest('.swe-notify-bell');
    if (!bell) return;
    event.preventDefault();
    openModal(bell);
  });

  // Warm the product request as soon as the shopper reaches for a bell
  const prefetch = event => {
    const bell = event.target instanceof Element && event.target.closest('.swe-notify-bell');
    const input = bell && bell.closest('.swatch-element')?.querySelector('input[data-product-url]');
    if (input) productJson(input.dataset.productUrl).catch(() => {});
  };
  document.addEventListener('pointerover', prefetch);
  document.addEventListener('focusin', prefetch);

  // Flow replaces the swatch markup on every variant change, so re-add bells after DOM updates
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      addBells();
    });
  }).observe(document.body, { childList: true, subtree: true });

  addBells();
})();
